import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <OmniLight3D>: a point light with attenuation, in a transform group so the
 * wireframe-sphere helper follows the light.
 */
import { useMemo, useRef } from 'react';
import { node3dGroupSpread, transformFromNode3DProperties } from '../../../../r3f/nodeTransform';
import { parseColorToHex } from '../../../../utils/colorParser';
import { omniShadowBias } from '../shared/shadowBias';
import { omniLight3DAabb } from '../../../../godot/scene/light';
import { NodeAabb } from '../../../../r3f/components/NodeAabb';
import { PointLightGizmo } from '../shared/lightHelpers';
import { positionalLightRange, usePositionalLight } from '../shared/positionalLight';
export function OmniLight3D({ node, children }) {
    const properties = node.properties;
    const lightRef = useRef(null);
    const transform = useMemo(() => transformFromNode3DProperties(properties), [properties]);
    const color = parseColorToHex(properties.light_color);
    const { distance, shadowNear, shadowFar } = positionalLightRange(properties.omni_range);
    const { intensity, shadowOpacity, userData } = usePositionalLight(lightRef, properties);
    const aabb = useMemo(() => omniLight3DAabb(properties.omni_range), [properties.omni_range]);
    return (_jsxs("group", { name: node.name, ...node3dGroupSpread(transform), children: [_jsx(NodeAabb, { aabb: aabb }), _jsx("pointLight", { ref: lightRef, color: color, intensity: intensity, distance: distance, decay: properties.omni_attenuation, castShadow: properties.shadow_enabled, "shadow-intensity": shadowOpacity, userData: userData, "shadow-camera-near": shadowNear, "shadow-camera-far": shadowFar, "shadow-bias": omniShadowBias(properties.shadow_bias) }), _jsx(PointLightGizmo, { lightRef: lightRef }), children] }));
}
//# sourceMappingURL=Component.js.map